module.exports = __webpack_public_path__ + "img/智慧物联.1c8a870e.png";